import React from 'react';
import { ForgotPasswordEmailForm, AuthPageLayout } from '@repo/common';

const ForgotPassword = () => {
  return (
    <AuthPageLayout
      title='Forgot password?'
      subtitle='Enter your email to reset your password'
    >
      <ForgotPasswordEmailForm />
    </AuthPageLayout>
  );
};

export default ForgotPassword;
